import React from 'react'

import { Switch } from 'react-router-dom'

import { TrainingRouteWithLayout } from './components'
import { TrainingJourneyLayout, TrainingMainLayout } from './layouts'
import TrainingPortalThemeProvider from 'providers/TrainingPortalThemeProvider'

import InviteCourse from 'views/Training/InviteCourse'
import Journey from 'views/Training/Journey'
import Home from 'views/Training/Home'
import CategoryCourses from 'views/Training/CategoryCourses'
import CourseDetail from 'views/Training/CourseDetail'
import CourseCertificate from 'views/Training/CourseCertificate'
import LessonContent from 'views/Training/LessonContent'
import ExerciseContent from 'views/Training/ExerciseContent'
import Profile from 'views/Training/Profile'

export const routes = {
  home: '/training/:portalToken/home',
  inviteCourse: '/training/:portalToken/invite_course/:coursePublicToken',
  journey: '/training/:portalToken',
  courseDetail: '/training/:portalToken/courses/:courseId',
  courseCertificate: '/training/:portalToken/courses/:courseId/certificate',
  lessonContent: '/training/:portalToken/courses/:courseId/lessons/:lessonId',
  exerciseContent:
    '/training/:portalToken/courses/:courseId/lessons/:lessonId/exercise',
  categoryHome: '/training/:portalToken/categories/:categoryId',
  profile: '/training/:portalToken/profile',
}

const TrainingRoutes = () => (
  <TrainingPortalThemeProvider>
    <Switch>
      <TrainingRouteWithLayout
        path={routes.categoryHome}
        component={CategoryCourses}
        layout={TrainingMainLayout}
        auth
        exact
      />
      <TrainingRouteWithLayout
        path={routes.exerciseContent}
        component={ExerciseContent}
        layout={TrainingMainLayout}
        auth
        exact
      />
      <TrainingRouteWithLayout
        path={routes.lessonContent}
        component={LessonContent}
        layout={TrainingMainLayout}
        auth
        exact
      />
      <TrainingRouteWithLayout
        path={routes.courseCertificate}
        component={CourseCertificate}
        layout={TrainingMainLayout}
        auth
        exact
      />
      <TrainingRouteWithLayout
        path={routes.courseDetail}
        component={CourseDetail}
        layout={TrainingMainLayout}
        auth
        exact
      />
      <TrainingRouteWithLayout
        path={routes.profile}
        component={Profile}
        layout={TrainingMainLayout}
        auth
        exact
      />
      <TrainingRouteWithLayout
        path={routes.home}
        component={Home}
        layout={TrainingMainLayout}
        auth
        exact
      />
      <TrainingRouteWithLayout
        path={routes.inviteCourse}
        component={InviteCourse}
        layout={TrainingJourneyLayout}
        exact
      />
      <TrainingRouteWithLayout
        path={routes.journey}
        component={Journey}
        layout={TrainingJourneyLayout}
        exact
      />
    </Switch>
  </TrainingPortalThemeProvider>
)

export default TrainingRoutes
